export { default } from './FloatingQRIcon';
